import { AppState } from 'store/types'

import { EnglishDialect } from './User.types'

export const selectCurrentUser = (state: AppState) => state.user.entity

// export const selectIsPlacementTestCompleted = (state: AppState) => state.user.entity?.profile.isPlacementTestCompleted

// export const selectUserHasSubscription = (state: AppState) => state.user.entity?.hasSubscription

// export const selectUpdateLists = (state: AppState) => state.user.updateLists

// export const selectIsRateUsPopupDismissed = (state: AppState) => state.user.rateUsPopupDismissed

// export const selectHasNpsModalBeenDisplayed = (state: AppState) => state.user.npsModalDisplayed

export const selectEnglishDialect = (state: AppState) => {
  const user = state.user.entity
  if (!user) return EnglishDialect.EnUS
  return user.profile.englishDialect ?? EnglishDialect.EnUS
}
